module.exports = __webpack_public_path__ + "static/media/Test20.481ed794.bmp";